window.Color = function() {
    var el = this;
    el.current = {};
    el.items = {};
    el.availables = {};
    
    var template = $('#product-colors-template').html();
    
    el.init = function() {
        var productId = el.product.id;

        if (!el.availables.hasOwnProperty(productId)) {
            el.current = {
                id: 0
            };
            
            return true;
        }
        
        var colorId = 0;
        if (el.items.hasOwnProperty(el.project.current.constructor.color_id)) {
            colorId = parseInt(el.project.current.constructor.color_id);
        }
        
        if (colorId === 0) {
            colorId = parseInt(el.availables[productId][0]);
        }
        
        el.current = el.items[colorId];
    };
    
    el.render = function() {
        var productId = el.product.id;
        
        var templateData = {
            items: [],
            is_show: false
        };
        
        var i, colorId;
        if (el.availables.hasOwnProperty(productId)) {
            for (i in el.availables[productId]) {
                colorId = el.availables[productId][i];

                templateData.items.push({
                    is_active: colorId === el.current.id ? true : false,
                    id: colorId,
                    name: el.items[colorId].name,
                    value: el.items[colorId].value
                });
            }
        }
        
        templateData.is_show = templateData.items.length > 0 ? true : false;
        
        var html = el.templater.render(template, templateData);
        $('.product-colors').html(html);
    };
    
    el.set = function (id) {
        el.current = el.items[id];
        el._parent.workData.color_id = id;
        
        el.render();
        el.workarea.render();
        el.preview.render();
    };
    
    $(document).on('change', '.js-set-color', function () {
        el.set($(this).val());
    });
};